import { FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { customerServiceIcon } from '../../../tornado/icon/icon.constants';
import { SCREEN_WIDTH } from '../../../tornado/utils/sizes';

export const LOGO_ICON = customerServiceIcon;

export const LOGO_ICON_SCALE = 1;

export const CATCH_PHRASE_MAX_LINES = 2;

export const CATCH_PHRASE_FONT = FONT.TOKYO_4;

export const CATCH_PHRASE_FONT_TYPE = FONT_TYPE.MAIN;

export const WORD_WRAP_WIDTH = {
  [HD]: Math.round(SCREEN_WIDTH[HD] * 0.775),
  [FULL_HD]: Math.round(SCREEN_WIDTH[FULL_HD] * 0.775),
};

export const PADDING_TOP = {
  [HD]: 0,
  [FULL_HD]: 0,
};

export const JUSTIFY_CONTENT = 'center';
